import { render, staticRenderFns } from "./installStep4.vue?vue&type=template&id=0ff23c93&scoped=true"
import script from "./installStep4.vue?vue&type=script&lang=js"
export * from "./installStep4.vue?vue&type=script&lang=js"
import style0 from "./installStep4.vue?vue&type=style&index=0&id=0ff23c93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff23c93",
  null
  
)

export default component.exports